import { render } from "./ProductDetailW.vue?vue&type=template&id=3ab5777e&scoped=true"
import script from "./ProductDetailW.vue?vue&type=script&lang=js"
export * from "./ProductDetailW.vue?vue&type=script&lang=js"

import "./ProductDetailW.vue?vue&type=style&index=0&id=3ab5777e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab5777e"]])

export default __exports__